import React from 'react'
import styles from './commentItemHeader.module.css'
import { AttachmentIcon } from '../../../../../../../../../Icons/attachmentIcon';
import { CommentItemType, PendingFile } from '../../../../../../../../createEscalation.models';
import { useCommentDropzone } from '../../../../../../../../createEscalations.hooks';
import { DefaultOptionColor } from '../../../../../../../../../../utils/constants/OptionsColors';
import { EscalationStatus, STATUS_COLORS } from '../../../../../../../../../../Pages/escalatedPage/escalatedPage.constants';
import { isTypeDraftComment, isTypeEmailSent, isTypeStatusChanged, isTypeEscalationRaised } from '../../commentItem.utils';
import { capitalizeFirstLetter } from '../../../../../../../../../../utils/stringUtils';

type CommentItemHeaderProps = {
    title: string;
    type: CommentItemType;
    status: string | null;
    pendingFiles: PendingFile[];
    setPendingFiles: React.Dispatch<React.SetStateAction<PendingFile[]>>;
}

export const CommentItemHeader = (props: CommentItemHeaderProps) => {
    const { title, type, status, pendingFiles, setPendingFiles } = props;

    const {
        getRootProps,
        getInputProps,
        open,
        attachmentButtonTitle,
    } = useCommentDropzone(pendingFiles, setPendingFiles);
    
    const emailSentDescriptionText: string | null = (isTypeEmailSent(type)) ? 'Escalation email has been sent successfully' : null;
    const showStatusDescription = (isTypeStatusChanged(type) || isTypeEscalationRaised(type)) && status;
    const showEmailSentDescription = isTypeEmailSent(type) && emailSentDescriptionText;

    return (
        <div className={styles.commentItemHeader}>
            <div className={styles.commentItemHeaderTitleContainer} {...getRootProps()}>
                <input {...getInputProps()} />
                <p className={styles.commentItemHeaderTitle}>{status === EscalationStatus.CLOSED ? "Escalation Closed" : title}</p>
                {isTypeDraftComment(type) &&
                    <button
                        type="button"
                        onClick={open}
                        className={styles.attachmentButton}
                        aria-label="Attach files"
                        title={attachmentButtonTitle}
                    >
                        <AttachmentIcon width={15} height={16} fillColor="#3EAE54" className={styles.escalationAttachmentIcon} />
                    </button>
                }
            </div>
            {showStatusDescription && (
                <p className={styles.commentItemHeaderDescription}>
                    Status: <span className={styles.commentItemHeaderDescriptionValue} style={{ color: STATUS_COLORS[status.toLowerCase() as keyof typeof STATUS_COLORS] || DefaultOptionColor }}>{capitalizeFirstLetter(status)}</span>
                </p>
            )}
            {showEmailSentDescription && (
                <p className={styles.commentItemHeaderDescription}>
                    {emailSentDescriptionText}
                </p>
            )}
        </div>
    )
}
